import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { TaxRulesTabColumns } from "../../../../../components/custom_tab/tabColumns";
import CompanyRateTaxRuleView from "./views/RateTaxRuleView";
import CompanyBenefitsTaxRuleView from "./views/BenefitsTaxRuleView";
import CompanyReliefTaxRuleView from "./views/ReliefTaxRuleView";
import useCompanyStore from "../../../../../state-management/useCompanyStore";

const CompanyTaxRules = () => {
	const { currentCompany } = useCompanyStore();
	const companyId = currentCompany?.id as number;

	const [searchParams, setSearchParams] = useSearchParams();
	const [rule, setRule] = useState(searchParams.get("taxRule") || "rate");

	const changeRule = (item: any) => {
		setRule(item.view);
		setSearchParams({
			view: searchParams.get("view") || "taxRules",
			taxRule: item.view,
		});
	};

	return (
		<div>
			<h2 className="text-2sm font-semibold mb-3">Tax Rules</h2>
			<hr className="mb-6" />
			<div className="flex space-x-6 border-b overflow-auto children-scroll-bar whitespace-nowrap w-full">
				{TaxRulesTabColumns.map((item: any, key) => (
					<button
						key={key}
						onClick={() => changeRule(item)}
						className={`flex ${
							rule === item.view
								? "border-b-2 border-primary-mango text-charcoal"
								: "text-gray-400"
						} pb-3`}
					>
						{item.name}
					</button>
				))}
			</div>
			{rule === "rate" && <CompanyRateTaxRuleView companyId={companyId} />}
			{rule === "benefit" && (
				<CompanyBenefitsTaxRuleView companyId={companyId} />
			)}
			{rule === "relief" && <CompanyReliefTaxRuleView companyId={companyId} />}
		</div>
	);
};

export default CompanyTaxRules;
